var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-b"},[_c('div',{staticClass:"container"},[_c('el-row',{attrs:{"gutter":100}},[_c('el-col',{attrs:{"md":{span:10, offset:7}}},[_c('Login')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }